import type { SchemaWithSlotLayout } from '@cli-types/core-engine/schema-reader.js'
import type { Schema } from '@cli-types/core-engine/schema.js'
import { collectSlotLayoutErrors } from './collect-slot-layout-errors.js'

export function collectSchemaSlotLayoutErrors(schema: Schema, errors: string[]): void {
  const input = schema as SchemaWithSlotLayout
  const hasFields = input.fields !== undefined
  const hasSlot = input.slot !== undefined

  if (!hasSlot) return

  if (hasFields) {
    errors.push('Schema cannot define both top-level "fields" and "slot". Use one layout source.')
  }

  collectSlotLayoutErrors(input.slot, 'slot', errors)
}
